import React from "react";
import { Link } from "react-router-dom";
import { Flex, Menu, Text } from "@mantine/core";
import styled from "styled-components";
import { IconChevronDown, IconExternalLink } from "@tabler/icons-react";

const textSize = "sm";

export default function Subnav({ buttonColor = "blue", links = [] }) {
  if (!links.length) return null;

  return (
    <StyledSubnav>
      <Flex
        align={{ base: "flex-start", md: "center" }}
        gap="xl"
        direction={{ base: "column", md: "row" }}
        wrap="nowrap"
      >
        {links.map((l, i) => {
          if (l.title) {
            return (
              <MenuLinkItem
                key={i}
                text={l.title}
                color={buttonColor}
                links={l.links}
              />
            );
          }
          return (
            <LinkButton
              key={i}
              to={l.to}
              text={l.text}
              color={buttonColor}
              target={l.target}
            />
          );
        })}
      </Flex>
    </StyledSubnav>
  );
}

const StyledSubnav = styled.div`
  background: #fff;
  border: 1px solid var(--mantine-color-gray-3);
  padding: var(--mantine-spacing-xs);
  border-radius: var(--mantine-radius-md);
  margin-bottom: var(--mantine-spacing-sm);
  padding: var(--mantine-spacing-md) var(--mantine-spacing-xl);
  width: 100%;
  overflow-x: auto;
`;

const LinkButton = ({ to, text, color, target = "_self" }) => {
  const isActive = to === window.location.pathname;
  return (
    <Flex align="center" gap="xs">
      <Text
        c={isActive ? color : "dark.4"}
        component={Link}
        to={to}
        size={textSize}
        fw={isActive ? 600 : 500}
        style={{
          minWidth: "max-content",
        }}
        target={target}
      >
        {text}
      </Text>
      {target === "_blank" && (
        <IconExternalLink size={12} color="var(--mantine-color-dark-2)" />
      )}
    </Flex>
  );
};

const MenuLinkItem = ({ text, color, links }) => {
  return (
    <Menu trigger="hover" openDelay={100} closeDelay={400}>
      <Menu.Target>
        <Flex align="center" gap="xs" style={{ cursor: "pointer" }}>
          <Text size={textSize} c="dark.4" fw={500}>
            {text}
          </Text>
          <IconChevronDown size={16} />
        </Flex>
      </Menu.Target>
      <Menu.Dropdown>
        {links.map((l, i) => (
          <Menu.Item>
            <StyledMenuItem>
              <LinkButton
                to={l.to}
                text={l.text}
                color={color}
                target={l.target}
              />
            </StyledMenuItem>
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};

const StyledMenuItem = styled.div`
  a {
    width: 100%;
    display: block;
  }
`;
